export default __webpack_public_path__ + "static/media/021.df344fa2.jpg";